import { GiftCardsApiClient } from '@fourthwall/services/dist/GiftCardsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useDeactivateGiftCardGroupMutation = createMutationHook(
  GiftCardsApiClient.deactivateGiftCardGroup,
  {
    mutationKey: ['deactivateGiftCardGroup'],
  },
)
